import React, { useEffect, useRef, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/SalesTab";
import PriceTypeList from "../Components/PriceType";
import ButtonColorList from "../Components/ButtonColor";
import DisplayOrder from "../Components/DisplayOrder";

const CenterSalesTab = ({ salesTabId,trigger }) => {

   const [tabName, setTabName] = useState("");
    const [buttonColor, setButtonColor] = useState("");
    const [displayOrder, setDisplayOrder] = useState("");
    const [locationId, setLocationId] = useState("");
    const [locationName, setLocationName] = useState("");
    const [priceTypeId, setPriceTypeId] = useState("");
    const [priceTypeName, setPriceTypeName] = useState("");
    const [buttonColorName, setButtonColorName] = useState("");
    const [editId, setEditId] = useState(null);
    const [errors, setErrors] = useState({});
    const [showSalesTapModal, setSalesTapModal] = useState(false);

    useEffect(() => {

        if (salesTabId) {
            console.log('salesTabId',salesTabId);
            setSalesTapModal(true);

            const fetchSalesTabDetails = async () => {
                try {
                    const payload = {
                        id: salesTabId,
                        limit: 1,
                        pageNumber: 1,
                    };

                    const response = await API.Sales_Tab_List(payload);
                    const fetchedData = response?.data?.data?.[0];

                    if (fetchedData) {
                        setEditId(fetchedData.id);
                        setTabName(fetchedData.tab_name);
                        setButtonColor(fetchedData.button_color_id);
                        setDisplayOrder(fetchedData.display_order);
                        setLocationId(fetchedData.location_id);
                        setPriceTypeId(fetchedData.price_type_id);
                        setPriceTypeName(fetchedData.price_type);
                        setButtonColorName(fetchedData.button_color);
                        setLocationName(fetchedData.location_name);
                    } else {
                        toast.error("Failed to fetch sales tab details.");
                    }
                } catch (error) {
                    if (error?.response?.status === 403) {
                        window.location.replace("/Login");
                    } else {
                        toast.error("Error fetching data.");
                        console.error("Error fetching sales tab details:", error);
                    }
                }
            };

            fetchSalesTabDetails();
        }
    }, [salesTabId,trigger]);

    const handleUpdate = async () => {
        if (!tabName) {
            toast.error("Please Enter a Tab Name.");
            return;
        }
        if (!buttonColor) {
            toast.error("Please select a Button Color.");
            return;
        }
        if (!displayOrder) {
            toast.error("Please select a Display Order.");
            return;
        }
        if (!priceTypeId) {
            toast.error("Please select a Price Type.");
            return;
        }

        try {
            const payload = {
                id: editId,
                tab_name: tabName,
                button_color: parseInt(buttonColor),
                display_order: displayOrder,
                location_id: parseInt(locationId),
                price_type_id: priceTypeId,
            };
            const response = await API.updateSalesTab(editId, payload);

            if (response.status === 200) {
                toast.success(response.data.message);
                setTimeout(() => window.location.reload(), 2000);
                //setEditId(null);
            } else {
                toast.error("Failed to update sales tab.");
            }
        } catch (error) {
            if (error.response) {
                const errorMsg = error.response.data.errors?.[0]?.msg || error.response.data.message || "An error occurred.";
                toast.error(`Error: ${errorMsg}`);
            } else if (error?.response?.status === 403) {
                window.location.replace("/Login");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    return (
        <>
            {showSalesTapModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Update Sales Tab</h5>
                                <button type="button" className="btn-close" onClick={() => setSalesTapModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label>Tab Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={tabName}
                                            onChange={(e) => setTabName(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <ButtonColorList
                                            selectedButtonColor={buttonColor}
                                            setSelectedButtonColor={setButtonColor}
                                            buttonColors={buttonColor}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <DisplayOrder
                                            selectedDisplayOrder={displayOrder}
                                            setSelectedDisplayOrder={setDisplayOrder}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <PriceTypeList
                                            selectedPriceType={priceTypeId}
                                            setSelectedPriceType={setPriceTypeId}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setSalesTapModal(false)}>
                                    Close
                                </button>
                                <button type="button" className="btn btn-primary" onClick={handleUpdate}>
                                    Save changes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </>
    );
};

export default CenterSalesTab;
